import React from 'react'

const TrustBox = () => {
  const ref = React.useRef(null)

  React.useEffect(() => {
    // Si window.Trustpilot est disponible, cela signifie que nous devons charger la TrustBox depuis notre référence.
    // Si ce n'est pas le cas, cela signifie que le script que vous avez collé dans <head /> n'est pas encore chargé.
    // Quand il sera chargé, la TrustBox sera automatiquement affichée.
    if (window.Trustpilot) {
      window.Trustpilot.loadFromElement(ref.current, true)
    }
  }, [])

  return (
    <div
      ref={ref} // Nous avons besoin d'une référence à cet élément pour charger la TrustBox dans l'effet (effect).
      className="trustpilot-widget" // Cette classe a été renommée « className ».
      data-locale="fr-FR"
      data-template-id="5419b6ffb0d04a076446a9af"
      data-businessunit-id="5ec78c5db0667500017d132b"
      data-style-height="20px"
      data-style-width="100%"
      data-theme="light"
    >
      <a href="https://fr.trustpilot.com/review/callalawyer.fr" target="_blank" rel="noopener">
        Trustpilot
      </a>
    </div>
  )
}

export default TrustBox
